function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg238SriLanka(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M0,0v512h512V0H0z M489.739,478.609h-267.13V33.391h267.13V478.609z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.609,
    y: 33.391,
    style: {
      fill: "#A2001D"
    },
    width: 267.13,
    height: 445.217
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.261,
    y: 107.598,
    style: {
      fill: "#D80027"
    },
    width: 200.348,
    height: 296.815
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.348,
    y: 85.337,
    style: {
      fill: "#FFDA44"
    },
    width: 22.261,
    height: 341.337
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.261,
    y: 33.391,
    style: {
      fill: "#6DA544"
    },
    width: 89.043,
    height: 445.217
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.304,
    y: 33.391,
    style: {
      fill: "#FF9811"
    },
    width: 89.043,
    height: 445.217
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M358.675,250.44v-44.522c0-7.424-11.13-14.848-11.13-14.848s-11.13,7.424-11.13,14.848h-44.522   v44.522h22.261v22.261c0,4.875,0.979,9.539,2.76,13.768l-10.184,8.493h-29.674V157.679c-12.299,0-22.261,9.973-22.261,22.261   v96.467c0,6.589,2.861,12.511,7.413,16.584v35.361h14.848v-18.554h66.783v29.685H328.99v14.837h29.685v-29.685l13.601-14.837   h44.288v29.685h-14.848v14.837h29.685v-29.685l13.601-14.837l12.552-40.259l-11.038-19.1h-38.945   C393.402,250.318,366.934,250.529,358.675,250.44z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "370.551,211.847 370.551,237.077 442.064,237.077 442.064,250.44 446.516,250.44    446.516,232.625 375.003,232.625 375.003,216.299 450.968,216.299 450.968,211.847  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.609,
    y: 33.391,
    style: {
      fill: "#FFDA44"
    },
    width: 22.261,
    height: 22.261
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.478,
    y: 33.391,
    style: {
      fill: "#FFDA44"
    },
    width: 22.261,
    height: 22.261
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.609,
    y: 456.348,
    style: {
      fill: "#FFDA44"
    },
    width: 22.261,
    height: 22.261
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.478,
    y: 456.348,
    style: {
      fill: "#FFDA44"
    },
    width: 22.261,
    height: 22.261
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg238SriLanka);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };